import React from 'react';
import './style.css'
// import { Clock } from "lucide-react";
import one from '../../assests/icon/Pasted image (4).png'
import two from '../../assests/icon/Pasted image (5).png'
import three from '../../assests/icon/img-1.png'
import four from '../../assests/icon/Pasted image (3).png'
import five from '../../assests/icon/Pasted image (2).png'
import six from '../../assests/icon/icon1.png';
import { Link } from 'react-router-dom';
import social from './Social_media/1.jpg'
import social2 from './Social_media/2.jpg'
import social3 from './Social_media/6.jpg'
import social4 from './Social_media/4.jpg'
import social5 from './Social_media/5.jpg'

const AboutSection = () => (
  <section className={`font-recoleta bg-black`}>
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start text-white pt-[120px] px-[48px] pb-[60px] justify-items-center">
      {/* LEFT SIDE - Heading */}
      <div className="space-y-4 lg:mr-0 mr-12">
        <h2 className="text-[48px] 2xl:text-[40px] lg:text-[36px]  font-black leading-[1.1]  text-cyan-400">
          About Us
        </h2>
        <h3 className="text-white text-[40px] lg:text-[32px] 2xl:text-[28px]  leading-10">
          Delivering Excellence in IT Since Our Inception
        </h3>
      </div>

      {/* RIGHT SIDE - Paragraph + Button */}
      <div className="lg:space-y-6 lg:max-w-[360px]">
        <p className="text-white/70 lg:text-[18px] text-[36px]">
          TekIT Software Solutions is where innovation meets execution. Since 2018, we’ve been crafting intelligent software, building scalable teams, and delivering AI-driven solutions that bring bold ideas to life. From startups to enterprises, our goal is simple—empower businesses with technology that performs, scales, and evolves with you.
        </p>
        <Link
          to="/about"
          target=""
          rel="noopener"
          className="inline-flex items-center gap-2 px-6 py-3 border border-cyan-400 rounded-[14px] bg-[#FF2F00] shadow-[inset_0px_2px_1px_rgba(255,255,255,0.5),inset_0px_0.6px_0.6px_-1.25px_rgba(255,255,255,0.72),inset_0px_2.3px_2.3px_-2.5px_rgba(255,255,255,0.64),inset_0px_10px_10px_-3.75px_rgba(255,255,255,0.25),inset_0px_14px_6px_-8px_rgba(0,170,255,0.2)] hover:bg-[#e12700] transition duration-300 lg:mt-0 mt-6"
        >
          <div className="transform -rotate-[23deg] w-5 h-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
              className="w-full h-full fill-white"
            >
              <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" />
            </svg>
          </div>
          <span className="text-white font-medium text-[30px] lg:text-[18px]">Know More</span>
        </Link>
      </div>
    </div>
  </section>

);
const services = [
  {
    title: "AI/ML Development ",
    description: "TekIT delivers smart AI/ML solutions to solve real business challenges—enabling predictive insights, automation, and better decision-making for optimized performance.",
    images: [
      social,
      social4,
    ],
    link: '/AI-ML-devlopment'
  },
  {
    title: "Software Development Services",
    description:
      "At TekIT, we believe in helping businesses innovate and upgrade with our highly efficient and personalised technology consulting services. Keeping our clients up-to-date with the latest technologies.",
    images: [
      social5,
    ],
    link: 'services'
  },
  {
    title: "Hire Dedicated Developers",
    description:
      "TekIT offers top-tier remote developers to help you scale your team quickly and cost-effectively. Our flexible hiring model ensures access to the right talent, smooth onboarding, and hassle-free remote collaboration.",
    images: [
      social2,
      social3,
    ],
    link: 'staffing'
  },


];

const ServicesSection = () => (
  <section className={` font-recoleta bg-black pt-[80px]`}>
    <h1 className="text-[64px] 2xl:text-[40px] lg:text-[36px] font-extrabold text-cyan-400 mb-12 text-center">Seamless IT Services for a Smarter Tomorrow </h1>
    <div className=" max-w-7xl bg-black p-6 grid lg:grid-cols-3 gap-6 justify-self-center">
      {services.map((service, index) => (
        <Link
          to={service.link}
          key={index}
          className="bg-[#171717] border border-[#292929] rounded-3xl p-6 shadow-[rgba(0,0,0,0.35)_-100px_1px_72px_0px] w-full transform rotate-1"
        >
          <div className="relative mask-gradient mb-4">
            {service.images.map((src, idx) => (
              <div
                key={idx}
                className={`absolute top-0 left-0 w-[92px] h-[92px] rounded-xl border-2 border-white border-opacity-30
                    ${idx === 0 ? "rotate-[-4deg] left-0 top-0 z-10" : ""}
                    ${idx === 1 ? "rotate-[4deg] left-[87px] top- z-20" : ""}
                    ${idx === 2 ? "rotate-[-4deg] left-44 top-0 z-30" : ""}
                    shadow-[rgba(0,0,0,0.33)_-0.7px_0px_0.7px]`}
              >
                <img
                  src={src}
                  alt="icon"
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
            ))}
            <div className="h-[92px]" />
          </div>
          <h3 className="text-white text-[40px] lg:text-[32px] 2xl:text-[28px] font-semibold mb-2">
            {service.title}
          </h3>
          <p className="text-white text-opacity-65 lg:text-[18px] text-[36px]">
            {service.description}
          </p>
        </Link>
      ))}
    </div>
  </section>
);

const cards = [
  {
    title: "Round The Clock Availability",
    description:
      "Need tech talent anytime? We’ve got you covered! Our experts are available round the clock to ensure seamless project execution.",
    background: six,
  },
  {
    title: "Highly qualified team",
    description:
      "Power up your projects with our Highly Qualified & Dedicated Team! Expert developers, seamless execution. Hire the best, achieve brilliance!",
    background: two,
  },
  {
    title: "SLA 4 Hours",
    description:
      "Swift Support, Guaranteed! With an SLA of just 4 hours, we ensure rapid issue resolution and uninterrupted workflow. Your success, our priority!",
    background: one,
  },
  {
    title: "Transparent Communication",
    description:
      "Transparent Communication, Every Step of the Way! No hidden surprises—just clear, honest, and real-time updates to keep your projects on track.",
    background: four,
  },
  {
    title: "Remote Onboarding & Support",
    description:
      "No geographical limitations when it comes to talent.",
    background: five,
  },
  {
    title: "Continuous Evaluation",
    description:
      "We constantly monitor the quality of work being provided.",
    background: three,
  },

];

const ClaritySection = () => (
  <section className="bg-black text-white px-6 py-20 w-full font-recoleta">
    <div className="max-w-7xl mx-auto text-center">
      <h1 className="text-[64px] 2xl:text-[40px] lg:text-[36px] font-extrabold text-cyan-400 mb-12">What Makes TekIT Different ?</h1>
      <div className="grid grid-cols-1  lg:grid-cols-3 lg:gap-6 gap-10">
        {cards.map((card, index) => (
          <div
            key={index}
            className="relative rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.25)] group hover:scale-105 transition-transform duration-300 bg-gray-900"
          >
            <div className="flex justify-center items-center">
              <img
                src={card.background}
                alt={card.title}
                className="w-20 h-full py-6 object-contain "
              />
            </div>
            <div className="px-6 pb-4  flex flex-col gap-3">
              <h4 className="text-white font-semibold text-[40px] lg:text-[20px] 2xl:text-[24px]">
                {card.title}
              </h4>
              <p className="text-white/80 lg:text-[16px] 2xl:text-[18px] text-[36px]">
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>



      {/* <div className="w-full max-w-md rounded-2xl border border-white/30 overflow-hidden shadow-lg bg-black">
                <div className="w-full justify-self-center">
                    <img
                        src="https://framerusercontent.com/images/A51VjfjDFU2Kgno5sTSckQpu6kw.png"
                        alt=""
                        className="w-[200px] object-contain"
                    />
                </div>

                <div className="p-6 flex flex-col gap-3">
                    <div className="w-6 h-6 text-white">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 256 256"
                            className="w-full h-full fill-white"
                        >
                            <path d="M136,72v43.05l36.42-18.21a8,8,0,0,1,7.16,14.31l-48,24A8,8,0,0,1,120,128V72a8,8,0,0,1,16,0Zm-8,144a88,88,0,1,1,88-88,8,8,0,0,0,16,0A104,104,0,1,0,128,232a8,8,0,0,0,0-16Zm103.73,5.94a8,8,0,1,1-15.46,4.11C213.44,215.42,203.46,208,192,208s-21.44,7.42-24.27,18.05A8,8,0,0,1,160,232a8.15,8.15,0,0,1-2.06-.27,8,8,0,0,1-5.67-9.79,40,40,0,0,1,17.11-23.32,32,32,0,1,1,45.23,0A40,40,0,0,1,231.73,221.94ZM176,176a16,16,0,1,0,16-16A16,16,0,0,0,176,176Z" />
                        </svg>
                    </div>

                    <h4 className="text-white text-lg font-semibold">
                        Round The Clock Availability
                    </h4>

                    <p className="text-white/65 text-sm">
                        Need tech talent anytime? We’ve got you covered! Our experts are
                        available round the clock to ensure seamless project execution. Hire
                        top developers, hassle-free!
                    </p>
                </div>
            </div> */}
    </div>
  </section>
);

const HomePage = () => (
  <main>
    <AboutSection />
    <ServicesSection />
    <ClaritySection />
  </main>
);

export default HomePage;
